import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import AddEditForm from "pages/EmployeeWorkspace/components/Tabs/components/AchievementAwards/components/AddEditForm";
import { formatDateForInput } from "utils/helpers/dateHelper";
import resource from "pages/EmployeeWorkspace/Resources/achievementAwardResource";

import schema from "pages/EmployeeWorkspace/validation/achievementAwardSchema";

const defaultValues = {
    description: "",
    awardDate: null,
    awardedBy: null
};

export default function FormDialog({ open, item, onSave, onCancel }) {
    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors }
    } = useForm({
        defaultValues,
        resolver: yupResolver(schema)
    });

    const onError = (errors) => {
        console.log({ errors });
    };

    useEffect(() => {
        if (open) {
            reset({
                ...defaultValues,
                ...item,
                awardDate: formatDateForInput(item?.awardDate)
            });
        }
    }, [open, item, reset]);

    const onSubmit = (data) => {
        onSave({
            ...data,
            awardDate: data?.awardDate || null
        });
    };

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="md" fullWidth>
            <DialogTitle>
                {item ? `Edit ${resource.title}` : `Add ${resource.title}`}
            </DialogTitle>

            <DialogContent dividers>
                <AddEditForm
                    register={register}
                    errors={errors}
                    control={control}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>

                <Button
                    variant="contained"
                    onClick={handleSubmit(onSubmit, onError)}
                >
                    Apply
                </Button>
            </DialogActions>
        </Dialog>
    );
}
